import { captureException, captureMessage } from '@sentry/react';

const logError = (error: Error) => captureException(error);
const logWarning = (warning: string) => captureMessage(warning, 'warning');
const logInfo = (message: string) => captureMessage(message, 'info');

export { logError, logWarning, logInfo };

const allowedTags = ['orgId', 'featureName'] as const;

type Tags = Record<(typeof allowedTags)[number], string | number | undefined>;

export const logErrorWithTags = (error: Error, tags: Tags) => {
  captureException(error, { tags });
};
